module.exports = __webpack_public_path__ + "static/media/image_white.eedd8d1e.png";